import React, { useEffect, useState } from 'react'
import useHttp from '../../../../hooks/use-http'
import { DEVICE, FOND_MODES, apiGenerator, compareTime, convertUTCToLocal } from '../../../../util/functions'
import CONSTANTS from '../../../../util/constant/CONSTANTS'
import ModalFormCreator from '../../../../component/common/ModalFormCreator'
import { useParams } from 'react-router-dom'
import Heading from '../../../../component/common/Heading'
import axios from 'axios'
import { role } from '../../../../util/Route'

const DeviceDetails = ({ deviceId }) => {
    const { id } = useParams()
    const [device, setDevice] = useState({})
    const [isOpen, setIsOpen] = useState(false);
    const [location, setLocation] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const api = useHttp()

    const commonClass = 'text-base font-medium py-2';
    const commonSpanClass = 'text-[#94A3BAE0]';

    console.log(location)

    const getLocation = async (latitude, longitude) => {
        try {
            setIsLoading(true)
            const response = await axios.get(
                `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`
            );
            const results = response.data.results;
            // console.log(results);
            if (results.length > 0) {
                setLocation(results[0].formatted_address);
                setIsOpen(false);
                setIsLoading(false);
            } else {
                setLocation('No results found');
                setIsLoading(false)
            }
        } catch (err) {
            console.error(err);
        }
    };

    const getLocationHandler = (value) => {
        // console.log(value);
        const LOCATION_API = apiGenerator(CONSTANTS.API.Location_history.verify, { petId: id })
        api.sendRequest(LOCATION_API, (res) => {
            if (res?.data?.locationData) {
                getLocation(res?.data?.locationData?.latitude, res?.data?.locationData?.longitude)
            }
            else {
                setLocation("no-location")
                setIsOpen(false)
            }

        }, { ...value })
    }

    // console.log(compareTime(device?.pet?.petMetaData?.[0], device?.pet?.petLocationTrackings?.[0]));


    useEffect(() => {
        if (deviceId) {
            const PET_DEVICE_API = apiGenerator(CONSTANTS.API.Pet_Device.getOne, { id: deviceId },)
            api.sendRequest(PET_DEVICE_API, (res) => {
                setDevice(res?.data)
                // if (res?.data?.pet?.petLocationTrackings?.length > 0 && role === 'ClientSupport') {
                //     getLocation(res?.data?.pet?.petLocationTrackings[0]?.latitude, res?.data?.pet?.petLocationTrackings[0]?.longitude)
                // }

            },)
        }
    }, [deviceId])
    return (
        <>
            <div>
                <ModalFormCreator
                    loading={api.isLoading || isLoading}
                    open={isOpen}
                    formWidth={600}
                    onCreate={getLocationHandler}
                    onCancel={() => {
                        setIsOpen(false);
                    }}
                    menuFields={CONSTANTS.FORM_FIELD.LOCATION_MODAL}
                    formData={{}}
                    name={"Location Details"}
                />
                {deviceId ?
                    <>
                        <Heading >Device Details</Heading>
                        <div className='my-2 flex gap-4 '>
                            <div>
                                <p className={`${commonClass}`}> <span className={`${commonSpanClass}`}> Device Type : </span>{DEVICE[device?.device?.deviceTypeId]}</p>
                                <p className={`${commonClass}`}><span className={`${commonSpanClass}`}> Device ID :</span> {device?.device?.DID}</p>
                                <p className={`${commonClass}`}><span className={`${commonSpanClass}`}> PCB ID :</span> {device?.device?.pcbId}</p>
                                <p className={`${commonClass}`}><span className={`${commonSpanClass}`}> IMEI NO :</span> {device?.imeiNumber}</p>
                                <p className={`${commonClass}`}><span className={`${commonSpanClass}`}> SIM ID :</span> {device?.device?.simId}</p>
                                <p className={`${commonClass}`}><span className={`${commonSpanClass}`}> Battery ID :</span> {device?.device?.batteryId}</p>
                                <p className={`${commonClass}`}><span className={`${commonSpanClass}`}> Sim Active :</span> {device?.device?.simStatus ? "Yes" :
                                    "No"}</p>
                            </div>
                            <div>
                                <p className={`${commonClass}`}> <span className={`${commonSpanClass}`}> Last Device Connected Date & Time : </span>{convertUTCToLocal(device?.createdAt, 'DD MMM YYYY, hh:mm A')}</p>
                                <p className={`${commonClass}`}> <span className={`${commonSpanClass}`}> Battery : </span>{device?.pet?.petMetaData[0]?.batteryLevel} %</p>
                                <p className={`${commonClass}`}> <span className={`${commonSpanClass}`}> Wifi Connected : </span>{compareTime(device?.pet?.petMetaData?.[0], device?.pet?.petLocationTrackings?.[0])?.wifiConnected ? 'Yes' : compareTime(device?.pet?.petMetaData?.[0], device?.pet?.petLocationTrackings?.[0])?.connected !== 'wifiData' ? 'Yes' : 'No'}</p>
                                <p className={`${commonClass}`}> <span className={`${commonSpanClass}`}> Dog Temperature : </span>{device?.pet?.petMetaData[0]?.temperature}  &#8451;</p>
                                <p className={`${commonClass}`}> <span className={`${commonSpanClass}`}> Last Location : </span>{convertUTCToLocal(device?.pet?.modeHistories[0]?.createdAt, 'DD MMM YYYY, hh:mm A')} {location && role === 'ClientSupport' ? location === 'no-location' ? <span className='text-red-600'> No Location Found</span> : <span>, {location}</span> : (location && role === 'Admin' ? location === 'no-location' ? <span className='text-red-600'> No Location Found</span> : <span>, {location}</span> : <span onClick={() => setIsOpen(prev => !prev)} className='text-[#0345A2] cursor-pointer'>See Location</span>)}</p>
                                <p className={`${commonClass}`}> <span className={`${commonSpanClass}`}> Last Mode : </span>{FOND_MODES[device?.pet?.modeHistories[0]?.mode]}</p>
                            </div>
                        </div>
                    </> :
                    <>
                        <p className='text-base mt-5 text-red-600 font-medium py-2'>Pet is not connected with device</p></>}

            </div>
        </>
    )
}

export default DeviceDetails